

import Vue from 'vue'
import Vant from 'vant'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import VueWechatTitle from 'vue-wechat-title'
import store from './store'

import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'
import VueScroller from 'vue-scroller'
import { getToken, setRedirectUrl, removeRedirectUrl, getLoginUserNo, setSignPackageKey, getSignPackageKey, removeSignPackageKey, hidePageNavInWechatBrowser, getMemberKey, setMemberKey, removeMemberKey } from '@/utils/auth'
import { getSignPackage } from '@/api/WeiXin'
import { getMemberInfo } from "@/api/Member";
import Loading from 'vux/src/components/loading/index.vue'


import wx from 'weixin-js-sdk'



Vue.config.productionTip = false
Vue.component('icon', Icon)
Vue.component('loading', Loading)
import toast from '../node_modules/vux/src/plugins/toast/index.js'
import loading from '../node_modules/vux/src/plugins/loading/index.js'
import '../node_modules/vant/lib/index.css'
Vue.use(toast)
Vue.use(loading)
Vue.use(Vuex)
Vue.use(Vant)


Vue.use(VueWechatTitle)
Vue.use(VueScroller)

router.beforeEach((to, from, next) => {
if (to.meta.requiresAuth) {  // 需要权限


if (getToken()) {
if(from.name == 'shopcartaddorder' && to.name == 'shopcart'){
to.meta.keepAlive = true;
}else{
to.meta.keepAlive = false;
}
removeRedirectUrl();
next();
} else {  // 无权，跳转登录
setRedirectUrl(to.fullPath)
next({
path: '/login',
query: {redirectUrl: to.fullPath}
})
}
} else {  // 不需要权限，直接访问
next({query: {memId: to.query.memId ? to.query.memId : (from.query.memId ? from.query.memId : '')}})
}
})
router.afterEach((to, from) => {
var postData = {
title: "铨洲科技-工业5.0" + to.meta.title,
memId: getLoginUserNo() ? getLoginUserNo() : ''
};
var data = {
RequestURI: window.location.href
};

var memId = getLoginUserNo() ? getLoginUserNo() : ''


if(memId != '' && getMemberKey() == undefined){
getMemberInfo(memId).then(response => {

var userInfo = response.ret_data
setMemberKey(userInfo)
})
}
hidePageNavInWechatBrowser()
getSignPackage(data).then(response => {

setSignPackageKey(response.ret_data)
if (response.code == 200) {
wx.config({
debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
appId: response.ret_data.appId, // 必填，公众号的唯一标识
timestamp: response.ret_data.timestamp, // 必填，生成签名的时间戳
nonceStr: response.ret_data.nonceStr, // 必填，生成签名的随机串
signature: response.ret_data.signature,// 必填，签名
jsApiList: [
'updateAppMessageShareData',
'updateTimelineShareData'
], // 必填，需要使用的 JS 接口列表
openTagList: ['wx-open-launch-weapp']
});
wx.miniProgram.postMessage({ data: postData });
wx.ready(function(){
wx.updateTimelineShareData({
title: "铨洲科技-工业5.0" + to.meta.title, // 分享标题
link: window.location.href, // 分享链接
imgUrl: document.location.origin + '/static/img/Nbanner3.126924f.jpg', // 分享图标
success: function () {



},
cancel: function () {


}
});
wx.updateAppMessageShareData({
title: "铨洲科技-工业5.0" + to.meta.title, // 分享标题
desc: '本平台立足于3C领域精密零部件制造行业。拥有一只两百人的技术服务团队，生产车间设有各类日本品牌设备600多台，检测仪器包括多台海克斯康三次元，基恩士投影，思瑞2.5次元等各类专业检测设备。支撑小批量，多品种零部件的高效生产配合，同时拥有大批量零部件制造的成本优势。', // 分享描述
link: window.location.href, // 分享链接
imgUrl: document.location.origin + '/static/img/Nbanner3.126924f.jpg', // 分享图标
success: function () {



},
cancel: function () {


}
});
});
}
})
})

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js